import { useEffect, useState } from 'react';
import { checkTouristsCount } from 'src/utils/touristsUtils/touristsUtils';

/**
 * Данный хук отвечает за проверку количества туристов на допустимое значение
 * Он предназанчен для своевременного показа попапа про допустимое количество туристов,
 * когда динамическая сига ещё не активна, но попап должен показаться во время рендера превью сиги
 * @param searchType
 * @param tourists
 * @returns {adultsValue, kidsValue, showTourisLimitPopup, setShowTourisLimitPopup}
 */

export const useTouristsLimitCount = (
  searchType: string,
  tourists?: { adults: number; kids: number[] },
) => {
  const [adultsValue, setAdultsValue] = useState<number>(tourists?.adults ?? 2);

  const [kidsValue, setKidsValue] = useState<number[]>(tourists?.kids ?? []);

  const [showTourisLimitPopup, setShowTourisLimitPopup] =
    useState<boolean>(false);

  useEffect(() => {
    const checkedTouristsValues = checkTouristsCount(searchType, tourists);

    setAdultsValue(checkedTouristsValues.adults);
    setKidsValue(checkedTouristsValues.kids);
    setShowTourisLimitPopup(checkedTouristsValues.limitPopupShown);
  }, [searchType, tourists]);

  return {
    adultsValue,
    kidsValue,
    showTourisLimitPopup,
    setShowTourisLimitPopup,
  };
};
